<div
    class="iframe"
    [ngClass]="classList">
    <iframe
        [src]="url | safeUrl"
        (load)="onLoadHandler($event)"></iframe>
</div>
